// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const SELECTOR_WRAPPER = '.p-early-years-resource-form';
const SELECTOR_FORM_WRAPPER = '.p-early-years-resource-form__wrapper';
const SELECTOR_FORM = '.p-early-years-resource-form__form';
const SELECTOR_FORM_BUTTON = '.p-early-years-resource-form__button';
const SELECTOR_FORM_CONFIRMATION = '.p-early-years-resource-form__confirmation-page';
const SELECTOR_FORM_DUPLICATION = '.p-early-years-resource-form__duplication';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class EarlyYerasResourceForm {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SELECTOR_FORM, this.formWrapper);
		this.formButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this._successContainer = SelectorEngine.findOne(SELECTOR_FORM_CONFIRMATION, this._wrapper);
		this._errorContainer = SelectorEngine.findOne('.p-early-years-resource-form__wrapper-error-container', this.formWrapper);
		this._errorText = SelectorEngine.findOne('.lta-snackbar__label', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);
		this._formDuplication = SelectorEngine.findOne(SELECTOR_FORM_DUPLICATION, this._wrapper)

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});
		this.getFormDetails();
	}

	async getFormDetails() {
		try {
			const url = '/api/earlyYearsResourceForm/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isRenderDependentQuestion: false,
			saveAddress: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.formButton, Events.Click, async () => {
			const isFormValid = await this.formGenerator.formValidation();
			if (isFormValid) {
				this.submitSupportForm(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
		this.answerList.isConsent = this.answerList?.isConsent?.[0].id;
		//this.answerList.courseDelivery = this.answerList?.courseDelivery.map((item) => item.label);
	}

	async submitSupportForm(answers) {
		this.formButton.disabled = true;

		try {
			const url = `/api/earlyYearsResourceForm/submit`;
			const responseData = await Request.post(url, answers, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { success, error, errorCode, errorMessage } = responseData;
			if (success) {
				this.formWrapper.classList.add('u-hidden');
				this._successContainer.classList.remove('u-hidden');
				window?.scrollTo?.({
					top: 0,
					behavior: 'smooth'
				});
			} else if(errorCode === '01') {
				this.formWrapper.classList.add('u-hidden');
				this._formDuplication.classList.remove('u-hidden');
				window?.scrollTo?.({
					top: 0,
					behavior: 'smooth'
				});
			}
				else {
				this._errorContainer.classList.remove('u-hidden');
				console.log(errorMessage);
				errorMessage ? this._errorText.innerText = errorMessage : '';
				this._errorContainer.scrollIntoView();
			}
		}
		catch {
			this._errorContainer.classList.remove('u-hidden');
			this.formWrapper.scrollIntoView();
		}
		finally {
			this.formButton.disabled = false;
		}
	}
}

const globalEarlyYerasResourceForm = new EarlyYerasResourceForm();
export default globalEarlyYerasResourceForm;
